var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-app"},[(this.$route.meta && this.$route.meta.requiresAuth)?_c('Sidebar'):_vm._e(),_c('router-view',{key:_vm.routerKey,staticClass:"main-content-wrapper",style:({
      marginLeft: this.$route.meta && this.$route.meta.requiresAuth && !_vm.isSidebarCollapsed
        ? '210px'
        : this.$route.meta && this.$route.meta.requiresAuth && _vm.isSidebarCollapsed ? '50px'
          : ''
    })})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }